<div class="wapper__expand wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{ 'proceso-ICA.procesos' | translate:{ entidad: nombreEntidad } }}
      </h2>
    </div>
    <div class="row align-items-center buscar-procesos">
      <form [formGroup]="form" class="row" (submit)="buscarExpediente()">
        <div class="col-12 col-md-4">
          <label for>{{ 'proceso-ICA.buscar-expediente' | translate }}</label>
        </div>
        <div class="col-12 col-md-8">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1"
              ><i class="fa fa-search"></i
            ></span>
            <input
              type="text"
              class="form-control"
              formControlName="numeroProceso"
              aria-label="numeroProceso"
              aria-describedby="basic-addon1" />
          </div>
        </div>
      </form>
      <div class="row" *ngIf="showResult">
        <div class="col-12">
          <span>
            {{ 'proceso-ICA.resultado' | translate }}
            <a
              class="detalle-expediente"
              [routerLink]="['/expediente/ica/', dataExpediente?.Id, dataExpediente?.Usuario_Id_Creador]"
              href="javascript:void(0)"
              >{{ 'proceso-ICA.expediente' | translate }} {{ proceso }}</a
            ></span
          >
        </div>
      </div>
      <div class="row" *ngIf="notFound">
        <div class="col-12 detalle-expediente">
          <span>{{ 'proceso-ICA.resultados' | translate }}</span>
        </div>
      </div>
      <br />
    </div>
    <br />
  </div>
  <app-power-bi-embed
    *ngIf="renderizarReporte"
    [embedUrl]="embedUrl"
    [embebedToken]="embedToken"
    [reportId]="reportId"
    [isMobile]="true"
    [heigth]="'800px'"
    [groupId]="groupId"
    [accessToken]="accessToken">
  </app-power-bi-embed>
  <div class="row align-items-center descargar-tablas">
    <div class="col-12 col-md-3">
      <span class="descargar-tablas__titulo">
        {{ 'proceso-ICA.descargar-info' | translate }}
      </span>
    </div>
    <div class="col-12 col-md-3">
      {{ 'proceso-ICA.info-asociada' | translate }}
    </div>
    <div class="col-12 col-md-3">
      <select class="form-select" [(ngModel)]="selectedYear">
        <option *ngFor="let year of yearsFilter" [value]="year">
          {{ year }}
        </option>
      </select>
    </div>
    <div class="col-12 col-md-3">
      <button class="btn-govco outline-btn-govco" (click)="downloadExcel()"
        [attr.aria-label]="'proceso-ICA.descargar' | translate">
        {{ 'proceso-ICA.descargar' | translate }}
      </button>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-start mt-5">
    <div>
      <b
        id="metricas"
        class="btn btn-govco outline-btn-govco hvr-shrink"
        routerLink="/metricas-entidad">
        {{ 'proceso-ICA.metricas' | translate }}
      </b>
    </div>
  </div>
</div>
